import { Skeleton, Stack } from "@mui/material";
import { TierIiReportStep } from "generated-graphql/graphql";

import { ChemicalSummaryTable } from "../../ChemicalSummaryTable";
import { ReportFloatingBar } from "../ReportFloatingBar";
import { useNavigateReportSaveCancel } from "../useNavigateReportSaveCancel";
import {
  useChemicalStepsIssueCounts,
  useReport,
  useReportingFacilityChemicalIssues,
} from "../useReport";
import { useTouchReportMutation } from "../useTouchReportMutation";

export function Summary() {
  const { data } = useReport();
  const facilityId = data?.tierIIReport.facility.id ?? "";
  const reportId = data?.tierIIReport.id ?? "";
  const navigateToOverview = useNavigateReportSaveCancel();
  const { handleSave, loading } = useTouchReportMutation(
    reportId,
    data?.tierIIReport.touchedSteps ?? [],
    TierIiReportStep.ChemicalSummary
  );

  const issues = useReportingFacilityChemicalIssues();
  const chemicalStepsIssueCounts = useChemicalStepsIssueCounts();

  if (!data?.tierIIReport) {
    return <Skeleton />;
  }

  return (
    <>
      <Stack
        sx={{
          height: "100%",
          flexDirection: "column",
        }}
      >
        <ChemicalSummaryTable facilityId={facilityId} reportId={reportId} />
      </Stack>
      <ReportFloatingBar
        onSaveClick={handleSave}
        loading={loading}
        onCancel={navigateToOverview}
        disabledWithAnyIssues
        issues={issues}
        issueCount={chemicalStepsIssueCounts[TierIiReportStep.ChemicalSummary]}
        saveText="Mark as Complete"
      />
    </>
  );
}
